<div
  class="flex shrink-0 items-center justify-center rounded-full tracking-tight"
  [ngClass]="{
    'bg-white text-black': color === 'white',
    'bg-black !text-white': color === 'black',
    'bg-blue-500 text-white': color === 'blue',
    'h-6 w-6 text-xs': size === 'small',
    'h-8 w-8 text-base': size === 'medium',
    'h-16 w-16 text-2xl': size === 'large',
  }">
  @if (userInitials()) {
    <span>{{ userInitials() }}</span>
  } @else {
    <i
      class="pi pi-user"
      [ngClass]="{
        '!text-xs': size === 'small',
        '!text-base': size === 'medium',
        '!text-2xl': size === 'large',
      }"></i>
  }
</div>
